import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from './auth-service.service';
import { BehaviorSubject, catchError, finalize, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActiveDriversService {

  get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService
  ) { }

  private _activeDrivers = new BehaviorSubject<any>({
    counts: {},
    count: 0,
    results: []
  });

  get activeDrivers$() {
    return this._activeDrivers.asObservable();
  }

  public isLoading = false;

  getActiveDrivers(page: number = 1, searchText: string = '', status: string = 'all') {
    this.isLoading = true;
    let tail = `${page}`;
    if (searchText) tail += `&search_text=${encodeURIComponent(searchText)}`;
    if (status) tail += `&status=${status}`;

    this.http
      .get<any>(`${this._liveApiUrl}/company/active-driver-listing/?page=${tail}`)
      .pipe(
        map((data) => data),
        catchError(this.authService.handleError),
        finalize(() => this.isLoading = false)
      )
      .subscribe(
        (res: any) => {
          if (res?.resultCode === '1') {
            this._activeDrivers.next(res.result);
          }
        },
        (_error) => {
          // Error toast is already shown by the interceptor (HTTP 500 → "Something went wrong on our end")
          // Avoid duplicate toast here
        }
      );
  }
}
